<template>
  <page-status class="order-pay" :loading="loading">
    <page-result
      :image="imgSuccess"
      title="提示"
      desc="请点击按钮，跳转小程序实名认证"
    >
      <div class="reload-action">
        <van-button block type="info" @click="onReload">跳转小程序</van-button>
      </div>
    </page-result>
  </page-status>
</template>

<script>
import * as qs from 'qs';

import PageStatus from '@/components/PageStatus';
import PageResult from '@/components/PageResult';
import imgSuccess from '@/assets/img-status-success.png';
import * as constants from '@/utils/constants';
import * as services from '@/services';

export default {
  name: 'WechatPay',
  components: {
    PageStatus,
    PageResult,
  },

  data() {
    return {
      loading: false,
      imgSuccess,
    };
  },

  created() {
    // this.handleWechat();
  },

  methods: {
    onReload() {
      // this.handleWechat();
      const myWindow = window;
      myWindow.wx.miniProgram.navigateTo({
        url: `/pages/car/wechat/wechat?${qs.stringify({
          ...this.$route.query,
          redirectUrl: `${window.location.origin}/insure-result?${qs.stringify({
            ...this.$route.query,
            isWechatAgent: 1,
          })}`,
        })}`,
      });
    },
    // orderPayment(
    //   orderNo,
    //   paymentType = '03',
    //   code,
    //   proposalNo,
    //   appid = 'wxf8b7f15bb6ee94e1',
    // ) {
    //   const { mobile, authToken } = this.$route.query;
    //   services
    //     .wechatOrderPayment(orderNo, paymentType, code, proposalNo, appid)
    //     .then(res => {
    //       if (res.data.iscertificate === '1') {
    //         const myWindow = window;
    //         myWindow.wx.miniProgram.navigateTo({
    //           url: `/pages/car/wechat/wechat?${qs.stringify({
    //             ...this.$route.query,
    //             openid: res.data.openid,
    //             orderNo,
    //             authToken,
    //             mobile,
    //             redirectUrl: `${
    //               window.location.origin
    //             }/insure-result?${qs.stringify({
    //               mobile,
    //               orderNo,
    //               authToken,
    //               isWechatAgent: 1,
    //             })}`,
    //           })}`,
    //         });
    //       } else {
    //         Toast({ message: '网络繁忙' });
    //       }
    //     })
    //     .catch(res => (this.loading = false));
    // },
    // handleWechat() {
    //   const { orderNo, code, proposalNo } = this.$route.query;
    //   const appid = 'wxf8b7f15bb6ee94e1'; // weixin wxe15d3c0802480692 公众号 wxf8b7f15bb6ee94e1 树保
    //   if (code) {
    //     this.orderPayment(orderNo, '03', code, proposalNo, appid);
    //   } else {
    //     const redirect_uri = window.location.href;
    //     const search = qs.stringify({ appid, redirect_uri });

    //     const url = 'https://app.cathay-ins.com.cn/wechat/oauth2/authorize';
    //     window.location.replace([url, search].join('?'));
    //   }
    // },
  },
};
</script>

<style lang="less">
.order-pay {
  height: 100%;

  .reload-action {
    margin: 12px 16px;
  }
}
</style>
